import React from 'react';
import ErrorImage from '../Assets/Images/404error.png';
import { LogoHeader } from '../Components/Inicio/LogoHeaderComponent';
import { NavMobile } from '../Components/Inicio/NavMobile';
import { NavDesktop } from '../Components/Inicio/NavDesktop';
import { Footer } from '../Components/Footer/FooterComponent';
import './Error404Page.css'

export const Error404 = (props) => {
    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n} />
            <NavMobile I18n={props.I18n} />
            <img className='image-error' src={ErrorImage} alt="Error 404" />
            <Footer I18n={props.I18n} />
        </>
    );
}
